"use client";

import { useLocale } from "next-intl";
import { useRouter, usePathname } from "next/navigation";
import { useTransition } from "react";

export default function LanguageSwitcher({ scrolled }) {
    const locale = useLocale();
    const router = useRouter();
    const pathname = usePathname();
    const [isPending, startTransition] = useTransition();

    const switchLocale = () => {
        const nextLocale = locale === 'en' ? 'ar' : 'en';
        const segments = pathname.split('/');
        segments[1] = nextLocale;
        const newPath = segments.join('/');

        startTransition(() => {
            router.replace(newPath);
        });
    };

    // Match the .link style from navbar.module.css
    // We need to dynamically apply text color based on scrolled state if possible, 
    // or just use the same classes if we can pass them down.
    // However, since this is a separate component, let's use inline styles or Tailwind to mimic it.
    // The navbar uses css modules, so we might need to accept a className prop or use global styles.
    // BUT, the simplest way to "look like others" is to remove the background and padding.

    const textColor = scrolled ? "text-[var(--marketing-navy)]" : "text-[var(--marketing-white)]";
    const hoverColor = "hover:text-[var(--marketing-gold)]";

    return (
        <button
            onClick={switchLocale}
            disabled={isPending}
            className={`flex items-center gap-1 font-medium text-[0.95rem] transition-colors duration-200 ${textColor} ${hoverColor}`}
            aria-label="Switch Language"
        >
            <span>{locale === 'en' ? '🇸🇦' : '🇺🇸'}</span>
            <span>{locale === 'en' ? 'العربية' : 'English'}</span>
        </button>
    );
}
